import CompanyLicense from "../types/companyLicense";
import User from "../types/user";
import checkRole, { UserRoles } from "./checkUserRoles";

const getPermissions = (
  loggedInUser: User,
  roleToCheck?: UserRoles,
  license?: CompanyLicense,
): boolean => {
  if (!license?.enabled) return false;

  if (license?.isTrial && new Date(license.trialEndDate!) <= new Date())
    return false;

  if (
    !license.isTrial &&
    (!license.purchaseDate || new Date(license.purchaseDate) > new Date())
  )
    return false;

  if (!loggedInUser) return false;

  if (roleToCheck) {
    const global = checkRole(loggedInUser, UserRoles.GlobalAdmin);
    if (!global && !checkRole(loggedInUser, roleToCheck)) return false;
  }

  return true;
};

export default getPermissions;
